import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { Button } from 'ds/components/button';
import { BasicButtonProps } from 'ds/components/button/BasicButton';
import { H3 } from 'ds/components/typography';


const MADAD_CARD_WIDTH = {
  large: {
    width: 376,
    height: 376,
  },
  medium: {
    width: 276,
    height: 334,
  },
};

export const Root = styled.div<{ isRegistered: boolean; size?: 'medium' | 'large'; isCarousel?: boolean; }>`
  ${({ theme, isRegistered, size = 'medium' }) => `
    display: flex;
    flex-direction: column;
    min-width: ${MADAD_CARD_WIDTH[size].width}px;
    max-width: ${MADAD_CARD_WIDTH[size].width}px;
    height: ${MADAD_CARD_WIDTH[size].height}px;
    background-color: ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.large};
    border: solid 1px ${theme.colors.neutrals.grey8};
    overflow: hidden;
    ${isRegistered ? `
      cursor: pointer;
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05), 0 2px 5px 0 rgba(0, 0, 0, 0.06);
      border-radius: 16px;

      &:hover {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.10);
      }
    ` : ''}
  `}
  ${({ theme, isCarousel }) => theme.media.showAt({ at: 1 })`
    ${isCarousel ? `
      max-width: calc(100vw - 64px);
      width: 320px;
    ` : `
      max-width: 100%;
      width: 100%;
    `}
  `}
`;

export const CardUpperSection = styled.div`
  position: relative;
`;

export const CardContentSection = styled.div`
  ${({ theme }) => `
    padding: ${theme.spacing(5)} ${theme.spacing(2)} ${theme.spacing(4)};
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .contact-agency-button {
      color: ${theme.colors.neutrals.grey1};
      margin: 0 auto;
    }
  `}
`;

export const CardContentDetails = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardCover = styled.div<{ imgUrl?: string; size?: 'medium' | 'large'; }>`
  ${({ theme, size, imgUrl }) => `
    height: ${size === 'medium' ? 96 : 120}px;
    background-color: ${colorToAlpha(theme.colors.neutrals.black, 0.5)};

    ${imgUrl ? `
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url("${imgUrl}");
    ` : ''}
  `}
`;

export const CardCoverBG = styled(CardCover)`
  ${({ size }) => `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: ${size === 'medium' ? 96 : 120}px;
    background: rgba(0, 0, 0, 0.50);
    backdrop-filter: blur(5px);
  `}
`;

export const TopTenBadgePosition = styled.div`
  ${({ theme }) => `
    position: absolute;
    top: 0;
    right: ${theme.spacing(2)};
  `}
`;

export const ContactButton = styled(Button)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin: 0 auto;
  :hover {
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }
`;
export const contactButtonDefaultProps: BasicButtonProps = {
  mode: 'ghost',
  size: 'large',
};
ContactButton.defaultProps = contactButtonDefaultProps;

export const AgencyName = styled(H3)<{ isRegistered: boolean; }>`
  ${({ theme, isRegistered }) => `
    align-items: center;
    color: ${isRegistered ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey3};
    white-space: nowrap;
    max-width: 100%;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const AgencyNameH2 = AgencyName.withComponent('h2');

export const CardLink = styled.div`
  & > a {
    text-decoration: inherit;
    color: inherit;
    width: 100%
  }

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;
